export default __webpack_public_path__ + "static/media/330_dummy2016-goldschmiede01-mobile-de.78456097.png";